var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgS1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_637_2078)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.504639,
    y: 0.223633,
    width: 72,
    height: 72,
    rx: 24,
    fill: "url(#paint0_linear_637_2078)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.754639,
    y: 0.473633,
    width: 71.5,
    height: 71.5,
    rx: 23.75,
    stroke: "url(#paint1_linear_637_2078)",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5455 17.6292C23.9869 17.6292 17.836 23.7734 17.836 31.3297C17.836 38.8882 23.9869 45.0391 31.5455 45.0391C39.0928 45.0391 45.2279 38.8882 45.2279 31.3297C45.2279 23.7734 39.0883 17.6292 31.5455 17.6292ZM31.5455 45.7914C23.568 45.7914 17.0792 39.3071 17.0792 31.3297C17.0792 23.3567 23.568 16.8747 31.5455 16.8747C39.5049 16.8747 45.9869 23.3612 45.9869 31.3297C45.9869 39.3071 39.5049 45.7914 31.5455 45.7914Z",
    fill: "#28B2E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.1015 53.4623L49.9281 45.2888L45.6465 49.5726L53.8109 57.7415C54.9663 58.8879 56.9551 58.8834 58.1015 57.746C59.2817 56.5681 59.2907 54.6469 58.1015 53.4623ZM48.0497 40.7731C46.401 43.6492 44.0272 46.0524 41.1758 47.7348L43.2524 49.8181L50.1713 42.8992L48.0497 40.7731ZM31.5452 13.8114C21.8808 13.8114 14.0182 21.6695 14.0182 31.3294C14.0182 40.9893 21.8808 48.8519 31.5452 48.8519C41.1983 48.8519 49.0519 40.9893 49.0519 31.3294C49.0519 21.6695 41.1983 13.8114 31.5452 13.8114ZM59.1713 58.8181C57.3898 60.5839 54.5317 60.5929 52.7411 58.8159L44.5722 50.6424L43.7884 51.4262C43.4934 51.719 43.0136 51.7235 42.7186 51.4262L39.7862 48.4848C37.2907 49.692 34.4934 50.3699 31.5452 50.3699C21.0452 50.3699 12.5046 41.8249 12.5046 31.3294C12.5046 20.8339 21.0452 12.2979 31.5452 12.2979C42.0317 12.2979 50.5677 20.8384 50.5677 31.3294C50.5677 34.1965 49.9236 36.9195 48.7817 39.3609L51.7794 42.3654C52.0722 42.6605 52.0722 43.1424 51.7794 43.4352L50.9979 44.2145L59.1758 52.3924C60.9438 54.1605 60.9528 57.0388 59.1713 58.8181Z",
    fill: "#28B2E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3988 36.3605C36.3312 36.4799 36.2028 36.5542 36.0677 36.5542C35.901 36.5542 35.7479 36.4416 35.7051 36.2772L33.365 27.8988L31.0339 36.2772C30.9911 36.4416 30.8425 36.5542 30.6713 36.5542C30.5024 36.5542 30.3515 36.4416 30.3087 36.2772L27.8898 27.6083L25.6218 32.7569C25.5632 32.892 25.4258 32.9821 25.2772 32.9821H21.5317C21.3222 32.9821 21.151 32.811 21.151 32.6037C21.151 32.3943 21.3222 32.2231 21.5317 32.2231H25.0249L27.6218 26.3335C27.6848 26.1893 27.8245 26.0947 27.9956 26.1083C28.1533 26.1218 28.2907 26.2321 28.3312 26.3853L30.6713 34.7637L32.9979 26.3853C33.0452 26.2231 33.1938 26.1083 33.365 26.1083C33.5362 26.1083 33.6848 26.2231 33.7321 26.3853L36.1893 35.2028L37.7794 32.4146C37.847 32.2952 37.9754 32.2231 38.1082 32.2231H41.5384C41.7524 32.2231 41.9168 32.3943 41.9168 32.6037C41.9168 32.811 41.7524 32.9821 41.5384 32.9821H38.329L36.3988 36.3605Z",
    fill: "#28B2E3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_637_2078",
    x: -19.4954,
    y: -19.7764,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_637_2078"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_637_2078",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_637_2078",
    x1: 36.5046,
    y1: 0.223633,
    x2: 36.5046,
    y2: 72.2236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_637_2078",
    x1: 36.5046,
    y1: 0.223633,
    x2: 36.5046,
    y2: 72.2236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#999999",
    stopOpacity: 0.4
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgS1);
export default __webpack_public_path__ + "static/media/s1.2d27f7819bfe0f2dc46bd1fe1f3c5f82.svg";
export { ForwardRef as ReactComponent };